import baseConf from './base.conf'

export default {
  ...baseConf,
  glapiHost: 'https://geekline.org',
  get glapiBaseUri () { return this.glapiHost + this.glapiRootUri }
}
